const config = {
    BASE_URL: 'https://dropshippaajat.herokuapp.com/',
    paypalClientID: 'AcmyYnP3sIM2qzO1LkhchsTCEdX3Bt2mh1M_J-0S6Ao1_kZR4wn4WzgkxdxyFHhISL2MsI8Cs9IfJqB2'
}

export default config